<template>
    <div>
        <gofix-card class="mb-0 heig-frame-child" fullContent>
            <gofix-default-table :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @row-click="clickToRowItem"
                @new-item="newItem"
                @delete-items="deleteItems"
                @export="exportItems"
                ref="gofixTable">
                <template slot="gofix_table:created_at" slot-scope="row">
                    {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
                <template slot="gofix_table:accepted_date" slot-scope="row">
                    {{row.item.accepted_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                </template>
                <template slot="gofix_table:total_net_amount" slot-scope="row">
                    {{row.item.total_net_amount  | formatMoney}}
                </template>
                <template slot="gofix_table:created_at" slot-scope="row">
                    {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
            </gofix-default-table>
        </gofix-card>
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Approval Request" 
            hide-footer 
            :centered="true" 
            v-model="modal.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Town Council"
                            vLabel="contract_name"
                            :filterable="false"
                            :append-to-body="true"
                            :required="true"
                            :options="modal.options.contracts"
                            @search="searchContract"
                            v-model="modal.data.town_council">
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Equipment Tag"
                            v-model="modal.data.equipment"
                            vLabel="tag_name"
                            required
                            :options="modal.options.equipments"
                            @search="searchEquipment"
                            :clearable="false" 
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <div class="flex">
                                    <div class="">
                                        <span>{{option.tagLocationPostalCode }}</span>
                                    </div>
                                </div>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <span>{{option.tagLocationPostalCode}}</span>
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                </b-row> 
                <b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Lift Code" oneline>{{ modal.data.lift_code }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Postal Code" oneline>{{ modal.data.postal_code }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Block No" oneline>{{ modal.data.block_number }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Lift No" oneline>{{ modal.data.lift_number }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row class="mb-26">
                    <b-col md="12">
                        <gofix-text-field class-label="width-115" label="Location" oneline>{{ modal.data.location && modal.data.location.name ? modal.data.location.name : null }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-input-textarea :rows="5" label="Description Of Replacement Work For Approval" v-model="modal.data.description"></gofix-form-input-textarea>
                    </b-col>
                </b-row>
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'defect-report-list',
        props: {
            name: {
                type: String,
                default: 'lmu-defect-report-listing'
            },
            is_supplier: {
                type: Boolean,
                default: false
            }
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['lmu_defect_report_listing']));
            return {
                tableConfig:{
                    name: this.name,
                    controls:{
                        create: this.is_supplier ? this.$checkRole(this.$accessModule.approval_request, 'create') : false,
                        delete: this.is_supplier ? this.$checkRole(this.$accessModule.approval_request, 'delete') : false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "created_at",
                    sortDirection: "desc"
                },
                tableItems: [],
                modal: {
                    open: false,
                    loading: false,
                    data: {
                        town_council: null,
                        equipment: null,
                        lift_code: null,
                        postal_code: null,
                        location: null,
                        block_number: null,
                        lift_number: null,
                        defect_summary: null,
                        requested_contact_no: null,
                        person_in_charge_name: null,
                        person_in_charge_contact_no: null,
                    },
                    options: {
                        contracts: [],
                        equipments: [],
                    }
                },
                timer: {
                    contracts: null,
                    equipments: null,
                    save: null
                },
                url: this.is_supplier ? 'supplier-portal' : 'v2'
            }
        },
        watch: {
            "modal.data.town_council": function(val) {
                this.modal.options.equipments = [];
                if(val) this.getEquipments()
            },
            "modal.data.equipment": function(val) {
                if(val) {
                    this.modal.data.lift_code = val.tag_name
                    this.modal.data.location = val.location_info
                    if(val.custom_fields) {
                        let custom_fields = val.custom_fields;
                        custom_fields.map(item => {
                            let key = item.attribute.name ? item.attribute.name.toLowerCase().replaceAll(' ', '_') : '';
                            if(key == 'block_no' || key == 'block_number') key = 'block_number';
                            if(key == 'lift_no' || key == 'lift_letter') key = 'lift_number';
                            if(this.modal.data.hasOwnProperty(key)) {
                                let value = item.value;
                                if(value && item.attribute.type === "DateTime") {
                                    value = moment(value).format("DD.MM.YYYY");
                                }
                                if(value){
                                    this.modal.data[key] = value;
                                }
                            }
                        })
                    }
                } else {
                    this.modal.data.lift_code = null
                    this.modal.data.location  = null
                    this.modal.data.postal_code  = null
                    this.modal.data.block_number = null
                    this.modal.data.lift_number  = null
                }
            }
        },
        created() {
            this.getContracts();
            if(this.ClientContractID && this.ClientContractID.id) {
                this.modal.data.town_council = this.ClientContractID
                this.getEquipments()
            }
        },
        methods:{
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("LMUApprovalRequestController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the list approval request", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.$router.push(`/${this.url}/approval-request/${item.id}`)
            },
            async deleteItems(callback) {
                const {
                    ids,
                    filter,
                    resolve,
                    reject
                } = await callback();
                await this.$store.dispatch('LMUApprovalRequestController/deleteItems', ids)
                .then(response => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    resolve(this.$notificationV2('deleting', 'defect_report'))
                })
                .catch(err => {
                    reject();
                })
            },
            /*---------------*/

            /*-- Get Data --------*/
            async getContracts(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.modal.options.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.modal.options.contracts = []
                loading(true);
                if(this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },

            async getEquipments(tag_name = null) {
                this.modal.options.equipments = []
                let tableRequest = {
                    filter: {
                        contract_id: this.modal.data.town_council.id,
                        tag_name: tag_name,
                        is_active: true,
                        location_in_lift: true
                    },
                    limit: 50,
                    isCMS: false,
                    sortColumn: 'tag_name',
                    sortDirection: 'ASC',
                }
                await this.$store.dispatch("PartReplacementController/getEquipment", tableRequest)
                .then(response => {
                    this.modal.options.equipments = response.items;
                }).catch(err => {})
            },
            async searchEquipment(search, loading) {
                loading(true)
                if (this.timer.equipments) {
                    clearTimeout(this.timer.equipments);
                    this.timer.equipments = null;
                }
                this.timer.equipments = setTimeout(async () => {
                    try {
                        await this.getEquipments(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            /*---------------*/

            /*-- Save Data --------*/
            newItem() {
                this.modal.data = {
                    town_council: null,
                    equipment: null,
                    lift_code: null,
                    postal_code: null,
                    location: null,
                    block_number: null,
                    lift_number: null,
                    description: null
                };
                if(this.ClientContractID && this.ClientContractID.id) {
                    this.modal.data.town_council = this.ClientContractID
                    this.getEquipments()
                }
                this.modal.open = true
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(async () => {
                    if(!this.modal.data.town_council) {
                        return this.$alertNotification("Please choose a town council.", "danger");
                    }
                    if(!this.modal.data.equipment) {
                        return this.$alertNotification("Please choose a equipment tag.", "danger");
                    }

                    this.modal.loading = true;
                    let objeClone = {
                        equipment_id:    this.modal.data.equipment.id,
                        client_contract_id: this.modal.data.town_council.id,
                        property_id:     this.modal.data.location && this.modal.data.location.id ? this.modal.data.location.id : null,
                        location:        this.modal.data.location && this.modal.data.location.name ? this.modal.data.location.name : null,
                        towncouncil:     this.modal.data.town_council.contract_name,
                        lift_code:       this.modal.data.lift_code,
                        postal_code:     this.modal.data.postal_code,
                        blk_number:      this.modal.data.block_number,
                        lift_number:     this.modal.data.lift_number,
                        description:     this.modal.data.description
                    };
                    
                    this.$store.dispatch("LMUApprovalRequestController/createItem", objeClone)
                    .then(async response => {
                        this.modal.loading = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.modal.open = false;
                        await this.$router.push(`/${this.url}/approval-request/${response.id}`)
                        await this.$alertNotification(this.$notificationV2('adding', 'defect_report'));
                    })
                    .catch(err => {
                        this.modal.loading = false;
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
            },

            /*--- Export File ---*/
            exportItems(tableRequest) {
                let request = JSON.parse(JSON.stringify(tableRequest));
                request.filter = {
                    client_contract_id: {type:"number",value: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null ,function:"=",with:[]},
                }
                request.limit = -1;
                request.page = 1;
                this.$store.dispatch( 'LMUApprovalRequestController/exportItems', request)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'LMUApprovalRequest.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
        }
    }
</script>